import BaseModel from './BaseModel';
import {Movie} from './Movies'
export default class FeaturedContent extends BaseModel {

    constructor(data) {
        super();
        this.add_trailer = data.add_trailer;
        this.banner_category = data.banner_category;
        this.button_1_external_url = data.button_1_external_url;
        this.button_1_text = data.button_1_text;
        this.button_1_url = data.button_1_url;
        this.button_2_external_url = data.button_2_external_url;
        this.button_2_text = data.button_2_text;
        this.button_2_url = data.button_2_url;
        this.description = data.description;
        this.dont_display_title = data.dont_display_title;
        this.image = data.image;
        this.logo_image = data.logo_image;
        this.mobile_image = data.mobile_image;
        this.movie = data.movie ? new Movie(data.movie) : null;
        this.strapline = data.strapline;
        this.title = data.title;
        this.appears_in = data.field_appears_in || 'BOTH';
        this.ad_tag = data.field_ad_tag;
        this.ad_tag_mobile = data.field_ad_tag_mobile;
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/FeaturedContent.js